import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import OECheckbox from '../../../../../../../global/oe-checkbox/oe-checkbox';
import { FormFieldProps } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { MODULE_DISPLAYED_FIELDS_SECTION_LABEL_TEXT } from '../../../../../../event-hubs.text';
import './speakers-display-fields.scss';

export type SpeakersDisplayField = {
    key: string;
    labelText: MessageDescriptor;
    field: FormFieldProps;
};

type SpeakersDisplayFieldsProps = {
    fields: SpeakersDisplayField[];
};

export const SpeakersDisplayFields: React.FC<SpeakersDisplayFieldsProps> = observer(({ fields }) => {
    const { formatMessage } = useIntl();

    return (
        <div className='speakers-display-fields'>
            <p className='speakers-display-fields__header'>
                <FormattedMessage {...MODULE_DISPLAYED_FIELDS_SECTION_LABEL_TEXT} />
            </p>
            <hr className='speakers-display-fields__divider' />
            <div className='speakers-display-fields__checkboxes'>
                {fields.map(({ key, labelText, field }) => (
                    <OECheckbox
                        key={key}
                        checked={field.value as boolean}
                        onChange={() => field.setValue(!field.value)}
                        label={formatMessage(labelText)}
                    />
                ))}
            </div>
            <hr className='speakers-display-fields__divider' />
        </div>
    );
});
